// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"8843d388","82":"441ea5aa","184":"e5a5e74c","306":"e6d2e73f","419":"aa9393b7","530":"15c4f652","632":"0c573a4e","880":"e8673170"}[chunkId] + ".chunk.js";
};